var site = site || {};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.extras = {};
site.extras.initDone = false;
/*
 Extras
 */
site.extras.upload =  {
	init: function(urls, lang) {
		if(site.extras.initDone === false) {
			site.extras.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG',
				'buttonText': lang.galleryImageAdd,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};

site.hash = {
	init: function() {
		$(window).hashchange( function() {
			var $body = $('body'),
				hash = location.hash.slice(1),
				elm = $('#'+hash),
				headerHeight = $('.sticky', '#header').height(),
				loggedIn = ($body.hasClass('loggedIn')) ? 31 : 0;

			if (elm && elm.offset()) {
				$('html,body').animate({
					scrollTop: elm.offset().top - (headerHeight + loggedIn + 20)
				}, 500);
				return false;
			}
		});

		$(window).load(function () {
			$(window).hashchange();
		});
	}
};

site.maps = {
	activeCategories: [],

	init:function() {
		$('.top .type', '#maps').on('click', function(e) {
			e.preventDefault();
			if ($(this).hasClass('active') || $(this).hasClass('zoom')) return;
			$(this).siblings().removeClass('active');
			$(this).addClass('active');

			var codename = $(this).data('codename');
			$('.map.active').removeClass('active');
			$('.'+codename).addClass('active');
		});

		$('.subTypes .type', '#maps').on('click', function(e) {
			e.preventDefault();
			$(this).toggleClass('active');

			site.maps.activeCategories = [];
			$('.subTypes .active', '#maps').each(function() {
				site.maps.activeCategories.push(parseInt($(this).data('typeid')));
			});

			$.each(moya.map.markers, function() {
				var $marker = this;
				if ($marker.setVisible) {
					if (site.maps.activeCategories.length == 0) {
						$marker.setVisible(true);
					}
					else {
						var markerTypeIds = [];

						if ($marker.typeIds) {
							markerTypeIds = $marker.typeIds.toString().split(',');
							markerTypeIds = markerTypeIds.map(function(x) {
								return parseInt(x);
							});
						}

						var visible = false;

						$.each(markerTypeIds, function(index,value) {
							if ($.inArray(value, site.maps.activeCategories) > -1) {
								visible = true;
							}
						});
						this.setVisible(visible);
					}
				}
			});
		});

		$('.top .type.zoom', '#maps').on('click', function(e) {
			e.preventDefault();
			if (!$(this).hasClass('active')) {
				$(this).siblings().removeClass('active');
				$(this).addClass('active');
			}

			var codename = $(this).data('codename'),
				map = moya.map.gMap;

			if (codename == 'island') {
				map.setCenter({lat: 65.04402080624236, lng: -18.788454});
				map.setZoom(7);
			}
			else if (codename == 'reykjavik') {
				map.setCenter({lat: 64.12286893330575, lng: -21.863939229492182});
				map.setZoom(12);
			}
			else if (codename == 'akureyri') {
				map.setCenter({lat: 65.68767027765722, lng: -18.124210301879877});
				map.setZoom(13);
			}
		});
	}
};
